<mat-card class="portal-notice">
  <mat-card-content>
    <div class="flex flex-col gap-4">
      <h2>Non-Refundable Fee:
        <span *ngIf="!paymentType?.fee" class="font-semibold">
          Payment amount can be viewed on the payments page after the application is submitted.
        </span>
        <span class="text-xl font-semibold">
          {{paymentType?.fee | currency:'USD': 'symbol':'1.2-2'}}
        </span>
      </h2>

      <span>
        {{paymentType?.notice}}
      </span>

      <span>Payment method options:</span>
      <ul>
        <li><span *ngIf="!canPay">Online</span> <button type="button" class="portal-text-action" *ngIf="canPay" (click)="pay()">Pay online</button></li>
        <li>Money Order</li>
        <li>Cashier's Check</li>
        <li>Personal/Business Check (personal and business checks are held for 21 days for clearance)</li>
        <li>Cash* <strong>Please Do Not Mail Cash</strong></li>
      </ul>

      <div class="flex flex-row justify-center items-start">
        <span><strong>Instructions for Submitting the Application and Fee Payment by Mail or In-Person</strong></span>
      </div>

      <span>
        Money orders and checks are payable to: <strong>OHA</strong>
        Money orders and cashier's checks take less time to clear than personal and business checks.
        Personal and business checks are held for 21 days for clearance. Applications will be reviewed
        once payment has been cleared. Application fees are non-refundable.
      </span>

      <div class="flex flex-col">
        <span>
          <strong>Mailing the application packet, money order or check, and remittance form:</strong>
        </span>
        <span>Oregon Health Authority - Public Health Division - Fiscal Services</span>
        <span>RE: HFLC</span>
        <span>PO Box 14260</span>
        <span>Portland, OR 97293-0260</span>
      </div>

      <div class="flex flex-col">
        <span><strong>In-person payment with a money order or check:</strong></span>
        <span>
          To make an in-person fee payment with a money order or check, print the remittance form and proceed to
          Cashier's Office on the second floor of the Portland State Office Building at 800 NE Oregon St, Suite 200,
          Portland, OR 97232 - Hours: 9am to 4pm, Mon to Fri
        </span>
      </div>

      <span>
        Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health Statistics window.
        If security asks if you have an appointment, you may let them know you are dropping off a payment for Business Name
        at the Cashier's Office window which does not require an appointment. Please include the remittance form with the payment.
      </span>

      <div class="flex flex-col">
        <span><strong>To make cash payment arrangements or for payment questions, please contact:</strong></span>
        <div class="flex flex-row gap-4 justify-start items-center" style="word-break: break-all; white-space: normal;">
          <a href="mailto:mailbox.inhomecare@odhsoha.oregon.gov ">
            <div class="flex flex-col sm:flex-row gap-4 justify-start items-start md:items-center">
              <span>mailbox.inhomecare&#64;odhsoha.oregon.gov</span>
              <mat-icon>email</mat-icon>
            </div>
          </a>
          <span>or (971) 673-0540</span>
        </div>
      </div>

      <div class="flex flex-col gap-2" *ngIf="canPay">
        <div>
          <button mat-raised-button color="primary" type="button" (click)="viewRemittanceSlip()">View Remittance Slip</button>
        </div>
        <div>
          <button mat-raised-button type='button' (click)="pay()" color="primary" *ngIf="canPay">Pay Online Now</button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
